module.exports = ".form-span-label {\n  font-size: 11px;\n  display: block;\n  padding-bottom: 5px;\n  color: #1a4e79;\n  padding-top: 5px;\n  font-weight: bold; }\n\n.form-span-label-nb {\n  font-size: 11px;\n  color: #428bca;\n  display: block;\n  padding-top: 5px;\n  padding-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tags/tags-edit.component.scss
// module id = ./src/app/components/tags/tags-edit.component.scss
// module chunks = main